import * as actionTypes from './actionTypes';
import { serviceProcessCip, serviceRefreshToken } from './services';
import { STATUS_CODE } from './constants';
import { reset } from 'redux-form';
import { openModal } from '@app/src/commons/modal/state/modals/actions';
import { CUOTEALO } from '@app/src/utils/validations/constants';
import { decodeAccessToken } from '@app/src/helpers/decodeAccessToken';
import { CONSTANTS } from '@app/src/views/CipReport/filter/state/validationReportToken/constants';
import { userLogout } from '@app/src/views/Login/login/state/login/actions';

const fetchProcessCipRequest = () => ({
  type: actionTypes.FETCH_PROCESSCIP_REQUEST
});

const fetchProcessCipFailure = (errorMessage: string) => ({
  type: actionTypes.FETCH_PROCESSCIP_FAILURE,
  errorMessage
});

const fetchProcessCipSuccess = (data) => ({
  type: actionTypes.FETCH_PROCESSCIP_SUCCESS,
  data
});

const fetchGetRefreshToken = () => ({
  type: actionTypes.FETCH_REFRESHTOKEN_REQUEST
});

const resetPaymentType = () => ({
  type: actionTypes.RESET_PAYMENT_TYPE
});

export const setPaymentType = (paymentType) => ({
  type: actionTypes.SET_PAYMENT_TYPE,
  paymentType
});

export const fetchProcessCip = (values: Object | any, url: string, reRunRefresh: boolean = true): Function => {
  return async dispatch => {
    dispatch(fetchProcessCipRequest());
    let newValues = {...values};
    newValues['amount'] = values.amount ? Number(values.amount) : '';
    newValues['expirationDate'] = `${values['date']} ${values['time']}`;
    newValues['serviceId'] = Number(decodeAccessToken('idService'));
    newValues['userId'] = Number(decodeAccessToken('idUser'));
    let userName = decodeAccessToken('username');
    newValues['serviceEmail'] = `${userName}`;
    newValues['paymentType'] = Number(values.paymentType);

    try {
      const data = await serviceProcessCip.getData(newValues, url);
      if (data.code === STATUS_CODE.OK) {
        dispatch(fetchProcessCipSuccess(data));
        if (newValues.paymentType !== CUOTEALO) {
          typeof document !== 'undefined' ? window.open(data.cipUrl, '_blank') : 'https://local.pagoefectivo/125';
        }
        dispatch(reset('generateForm'));
        dispatch(resetPaymentType());
        return;
      }
      dispatch(fetchProcessCipFailure(data.message));
    } catch(e) {
      if (e.code === CONSTANTS.notAuthorized || e.code === CONSTANTS.errorToken) {
        dispatch(fetchProcessCipFailure(e.message));
        return;
      }
      if (e.code === CONSTANTS.expiredAccessToken && reRunRefresh) {
        await dispatch(fetchRefreshToken(newValues, url));
        return;
      }
      if (e.code === CONSTANTS.errorValidationRole) {
        dispatch(openModal('CLOSE_SESSION_MODAL'));
        return;
      }
      dispatch(fetchProcessCipFailure('Conexión Fallida'));
    }
  }
}

const fetchRefreshToken = (newValues, url) => {
  return async dispatch => {
    dispatch(fetchGetRefreshToken());
    try {
      const refreshToken = localStorage.getItem('refreshtoken');
      const { data } = await serviceRefreshToken.getData(refreshToken);
      await dispatch(fetchProcessCip(newValues, url, false));
    } catch (error) {
      await dispatch(userLogout())
    }
  }
}
